import React, { useEffect, useRef, useState } from "react";
import ToggleSwitch from "../../Components/ToggleSwitch";
import FileUpload from "../../Components/FileUpload";
import Confirm from "../../Components/confirm";
import ToastManager from "../../Components/ToastManager";
import { CommonUtil } from "../../utils/CommonUtil";
import { NetworkManager } from "../../Components/NetworkManager";
import ColorPicker from "../../Components/ColorPicker";
import BusyLoader from "../../Components/BusyLoader";
import NoDocument from "./NoDocument";
import ReactSelectField from "../../Components/ReactSelectField";
import { default as ReactSelect, components } from "react-select";

const GeneralDetails = ({unSavedChanges}:any) => {
  const saasOrgId =  CommonUtil.getSaasOrgId()
  const dropMobileImage = useRef<any>();
  const [configDetails, setConfigDetails] = useState<any>([]);
  const [lateChargePerDay, setLateChargePerDay] = useState<any>(null);
  const [mobileColorCode, setMobileColorCode] = useState<any>("#000000");
  const [mobileImageFiles, setMobileImageFiles] = useState<any>({});
  const [unSaved, setUnSaved] = useState<boolean>(false);
  const [documentType, setDocumentType] = useState<any>([]);
  const [selectedDocType, setSelectedDocType] = useState<any>([]);
  const [completedDocDays, setCompletedDocDays] = useState<any>(7);
  const [pdfTemplateOne, setPdfTemplateOne] = useState<boolean>(true);
  const [pdfTemplateTwo, setPdfTemplateTwo] = useState<boolean>(false);
  const defaultTaskStatuses = [
    "bad", "CONFORME", "Fail", "good", "N/A", "NA", "no", 
    "NON-CONFORMEEEE", "noo", "not ok", "ok", "Pass", "yes", "yes,no", "yess"
  ].map(s => ({label: s, value: s}));
  const [pdfTemplateOneImagesBottom, setPdfTemplateOneImagesBottom] = useState<boolean>(true);
  const [pdfTemplateOneImagesProcess, setPdfTemplateOneImagesProcess] = useState<boolean>(false);
  const [pdfConfigRequests, setPdfConfigRequests] = useState<any[]>([]);
  const [allTaskStatuses, setAllTaskStatuses] = useState<any>([]);
  const [toggles, setToggles] = useState<any>({
    equipmentUsingMobile: false,
    createEquipmentDoc: false,
    viewEquipmentDetails: false,
    webClaim: false,
    mobileClaim: false,
    compareRequired: false,
    completedDocOnMobile: false,
  });
  const initialState = useRef<any>({
    lateChargePerDay,
    mobileColorCode,
    mobileImageFiles,
    toggles,
    completedDocDays,
    pdfTemplateOne,
    pdfTemplateTwo,
    pdfTemplateOneImagesBottom,
    pdfTemplateOneImagesProcess,
    pdfConfigRequests,
  });
  const widgets = [
    {label: "Document Type", value: "Document Type"},
    {label: "Document Comparison", value: "Document Comparison"}, 
    {label: "Forced Complete", value: "Forced Complete"},
    {label: "Claims", value: "Claims"},
    {label: "Broker/Carrier", value: "Broker/Carrier"},
    {label: "Historical Data", value: "Historical Data"}
  ];
  let agreeFileName = '';
  let mobileImgName = '';
  let uploadType = '';
  let fileData = {};
  let filePath = '';

  useEffect(() => {
    getAllConfig();
    getAllDocumentTypes();
  }, []);

  const onLoginError = (err: any) => {
    console.log(err);
  };
  
  const getAllConfig = () =>{
    const orgUrl = `api/v2/config/all/?orgId=${saasOrgId}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, onGetAllConfig, onLoginError);
  };

  const onGetAllConfig = (dataObj: any) => {
    if (dataObj) {
      const config = JSON.parse(dataObj);
      setConfigDetails(config);

      let fetchedTaskStatuses: any[] = [];
      if (config.pdfConfigs && config.pdfConfigs.length > 0) {
        fetchedTaskStatuses = config.pdfConfigs.map((c: any) => c.status);
      } else if (config.taskStatus && config.taskStatus.Task_statuses) {
        fetchedTaskStatuses = config.taskStatus.Task_statuses;
      }
      setAllTaskStatuses(fetchedTaskStatuses);

      const newState = {
        toggles: {
          equipmentUsingMobile: config.equipmentUsingMobile || false,
          createEquipmentDoc: config?.createEquipmentDoc || false,
          viewEquipmentDetails: config.viewEquipmentDetails || false,
          webClaim: config.webClaim || false,
          mobileClaim: config.mobileClaim || false,
          compareRequired: config.compareRequired || false,
          completedDocOnMobile: config.completedDocOnMobile || false,
        },
        lateChargePerDay: config.lateChargePerDay || null,
        mobileColorCode: config.mobileColorCode || "#000000",
        mobileImageFiles: {
          name: config.mobileLandingFileName,
          path: config.mobileLandingFilePath,
        },
        selectedDocType: config.compareDocTypes ? Object.entries(config.compareDocTypes).map(([key, value]) => ({
          label: key,
          value: value,
        })) : [],
        completedDocDays: config.completedDocDays,
        pdfTemplateOne: config.pdfTemplateOne !== undefined ? config.pdfTemplateOne : true,
        pdfTemplateTwo: config.pdfTemplateTwo !== undefined ? config.pdfTemplateTwo : false,
        pdfTemplateOneImagesBottom: config.pdfTemplateOneImagesBottom !== undefined ? config.pdfTemplateOneImagesBottom : true,
        pdfTemplateOneImagesProcess: config.pdfTemplateOneImagesProcess !== undefined ? config.pdfTemplateOneImagesProcess : false,
        pdfConfigRequests: config.pdfConfigs || [],
      };

      setToggles(newState.toggles);
      setLateChargePerDay(newState.lateChargePerDay);
      setMobileColorCode(newState.mobileColorCode);
      setMobileImageFiles(newState.mobileImageFiles);
      setSelectedDocType((prev: any) => (prev !== newState.selectedDocType ? newState.selectedDocType || [] : prev));
      setCompletedDocDays(newState.completedDocDays);
      setPdfTemplateOne(newState.pdfTemplateOne);
      setPdfTemplateTwo(newState.pdfTemplateTwo);
      setPdfTemplateOneImagesBottom(newState.pdfTemplateOneImagesBottom);
      setPdfTemplateOneImagesProcess(newState.pdfTemplateOneImagesProcess);
      setPdfConfigRequests(newState.pdfConfigRequests);
      initialState.current = newState;
    }
  };
  
  const getAllDocumentTypes = () =>{
    const orgUrl = `api/v2/config/document-types/all/?orgId=${saasOrgId}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, (dataObj: any) =>{
      if (dataObj) {
        const restData = JSON.parse(dataObj);
        if (restData && restData?.length > 0) {
          const docType = restData?.map((item: any) => ({
            value: item.documentTypesId,
            label: item.documentTypesName,
          }));
          setDocumentType(docType);
        } else {
          setDocumentType([]);
        }
      }
    },
    onLoginError)
  };

  useEffect(() => {
    const isDifferent =
      JSON.stringify(initialState.current) !==
      JSON.stringify({toggles, lateChargePerDay, mobileColorCode, mobileImageFiles, selectedDocType, completedDocDays, pdfTemplateOne, pdfTemplateTwo, pdfTemplateOneImagesBottom, pdfTemplateOneImagesProcess, pdfConfigRequests})
    setUnSaved(isDifferent);
    unSavedChanges(isDifferent);
  }, [toggles, lateChargePerDay,  mobileColorCode, mobileImageFiles, selectedDocType, completedDocDays, pdfTemplateOne, pdfTemplateTwo, pdfTemplateOneImagesBottom, pdfTemplateOneImagesProcess, pdfConfigRequests]);

  const handleToggleChange = (key: string, value: boolean) => {
    setToggles((prevState:any) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleRentalChargesChange = (e:any) => {
    setLateChargePerDay(e.target.value);
  };

  const mobileImageUpload = (files: any) => {
    fileData = files;
    mobileImgName = files.name;
    uploadType = "mobileImage"
    BusyLoader.showLoader();
    if (mobileImgName) {
      filePath = `interchange/mobileImage/${CommonUtil.getSelectedOrgId()}/${mobileImgName}`;
      var qParam: string = `objectPath=${filePath}`;
      NetworkManager.sendJsonRequest("api/session/uploadUrl", "", qParam, "GET", false, onUploadSuccess, onLoginError);
    }
  };
  
  const onUploadSuccess = (dataObj: any) => {
    if (dataObj) {
      if (dataObj.statusCode) {
        BusyLoader.hideLoader();
        ToastManager.showToast(dataObj.errorMessage, "Error");
      }else{
        var strUploadPath = dataObj;
        if ((agreeFileName || mobileImgName) !== '') {
          var myHeaders = new Headers();
          var requestOptions: any = {
            method: "PUT",
            headers: myHeaders,
            body: fileData,
            redirect: "follow",
          };
          fetch(strUploadPath, requestOptions)
            .then((response) => response.text())
            .then((result) => {
              BusyLoader.hideLoader();
              if (uploadType == "mobileImage"){
                setMobileImageFiles({
                  ...mobileImageFiles,
                  name: mobileImgName,
                  path: filePath})
              }
              agreeFileName = '';
              mobileImgName = '';
              uploadType = '';
              filePath = '';
              fileData = {};
            })
            .catch((error) => {
              BusyLoader.hideLoader();
              console.log("error", error);
            });
        }
      }
    }
  };

  const handleSave = async () => {    // if((toggles?.compareRequired && selectedDocType?.length === 0)){
    //   ToastManager.showToast("Mandatory Fields Required", "Error");
    //   return;
    // }

    const payload = {
      configId: configDetails?.configId,
      equipmentUsingMobile: toggles.equipmentUsingMobile,
      createEquipmentDoc: toggles?.createEquipmentDoc,
      viewEquipmentDetails: toggles.viewEquipmentDetails,
      compareRequired: toggles?.compareRequired,
      docTypeId: selectedDocType?.map((item: any) => item.value ) || [],
      // widgets: selectedWidgets?.map((item: any) => item.value ) || null,
      mobileLandingFileName: mobileImageFiles ? mobileImageFiles.name : "",
      mobileLandingFilePath: mobileImageFiles ? mobileImageFiles.path || "" : "",
      mobileColorCode: mobileColorCode || "",
      webClaim: toggles.webClaim,
      mobileClaim: toggles.mobileClaim,
      saasOrgId: saasOrgId,
      inspectionOrgId: saasOrgId, 
      lateChargePerDay: lateChargePerDay,
      completedDocOnMobile: toggles.completedDocOnMobile,
      completedDocDays: completedDocDays,
      pdfTemplateOne: pdfTemplateOne,
      pdfTemplateTwo: pdfTemplateTwo,
      pdfTemplateOneImagesBottom: pdfTemplateOneImagesBottom,
      pdfTemplateOneImagesProcess: pdfTemplateOneImagesProcess,
      pdfConfigs: allTaskStatuses?.map((s: any) => {
        const existing = pdfConfigRequests.find((r: any) => r.status === s);
        return {
          status: s,
          isFlagged: existing ? existing.isFlagged : false,
          color: existing ? existing.color : "#000000",
        };
      }),
    };
  
    console.log(payload, "payload");
    const url = configDetails?.configId
    ? `api/v2/config/${configDetails?.configId}/?orgId=${saasOrgId}`
    : `api/v2/config/?orgId=${saasOrgId}`;

  NetworkManager.sendJsonRequest(url, payload, "", configDetails?.configId ? "PUT" : "POST", true, onSubmitSuccess, (err: any) => {
    console.log(err);
  });
};
  
  
    const onSubmitSuccess = (dataObj: any) => {
      if (dataObj) {
        const restData = JSON.parse(dataObj);
        if (!restData?.errorMessage) {
          ToastManager.showToast("General Details Saved Successfully", "Success");
          setConfigDetails([]);
        }else{
          ToastManager.showToast(restData.errorMessage, "Error");
        }
        getAllConfig();
      }
    };

  const removeFile = (fileType: any) => {
    Confirm.show("Confirm", "Would you like to delete this File?", [
      {
        label: "Yes",
        callback: function () {
          if(fileType == "mobileImage"){
            setMobileImageFiles({...mobileImageFiles, name: "", path: "" })
          }
          ToastManager.showToast("File Removed", "Info");
        },
      },
      { label: "No" },
    ]);
  };

  const handleStatusConfigChange = (status: string, key: string, value: any) => {
    setPdfConfigRequests(prev => {
      const existing = prev.find(p => p.status === status);
      if (existing) {
        return prev.map(p => p.status === status ? { ...p, [key]: value } : p);
      } else {
        return [...prev, { status, isFlagged: key === 'isFlagged' ? value : false, color: key === 'color' ? value : "#000000" }];
      }
    });
  };

  return (
    <>
      <NoDocument>
      <div className="col-lg-12 d-flex justify-content-end align-item-center">
        <button 
          className="btn btn-dark" 
          onClick={handleSave} 
          disabled={!unSaved}
        >
          Save
        </button>
        </div>
        </NoDocument>
      <div className="col-lg-12" style={{overflowY: "auto", overflowX: "hidden", height:`${window.innerHeight - 220}px`, paddingRight:"12px"}}>
          <div className="row mb-4">
            <h5 className="mb-4">Equipment Configuration:</h5>
            <div className="row ms-2">
              <h6 className="eqp-sub-head">Equipment Creation using the Mobile Application</h6>
              <div className="ms-4 g-0">
                <div className="d-flex p-0" >
                  <ToggleSwitch
                    checked={toggles.equipmentUsingMobile}
                    onChange={(value :any) => handleToggleChange("equipmentUsingMobile", value)}
                    label="Add a menu option for Equipment Creation using the Mobile Application"
                    isDisabled={true}
                  />
                  <a className="ms-1 align-self-center">
                    <img className=" pe-auto" 
                    src={ "./../images/info.svg"} alt="info" width={16} height={16}
                    title="Option will be available on the main menu screen."/>
                  </a>
                </div>
                <div className="d-flex p-0 " >
                  <ToggleSwitch
                    checked={toggles.createEquipmentDoc}
                    onChange={(value :any) => handleToggleChange("createEquipmentDoc", value)}
                    label="Add an option for equipment creation on document screen"
                    isDisabled={true}
                  />
                  <a className="ms-1 align-self-center">
                    <img className=" pe-auto" 
                    src={ "./../images/info.svg"} alt="info" width={16} height={16}
                    title="Option will be available on create document screen."/>
                  </a>
                </div>
              </div>
              <div className="ms-0 p-0">
                <h6 className="eqp-sub-head">View Equipment Details using the Mobile Application</h6>
                <div className="ms-4">
                  <div className="d-flex p-0 " >
                    <ToggleSwitch
                      checked={toggles.viewEquipmentDetails}
                      onChange={(value :any) => handleToggleChange("viewEquipmentDetails", value)}
                      label="Add a menu option for viewing Equipment details"
                    />
                    <a className="ms-1 align-self-center">
                      <img className=" pe-auto" 
                      src={ "./../images/info.svg"} alt="info" width={16} height={16}
                      title="Enabling this option will allow the trailer to be released multiple times before returning the trailer."/>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className="pro-border d-none" />
          <div className="row mb-4 d-none">
            <h5 className="mb-3">Documents Comparison:​​</h5>
            <div className="d-flex ms-4 mb-3" style={{position:"relative"}}>
              <div className="d-flex p-0 " >
                <ToggleSwitch
                  checked={toggles.compareRequired}
                  onChange={(value :any) => handleToggleChange("compareRequired", value)}
                  label="Documents Comparison Required?"
                />
                <a className="ms-1 align-self-center">
                  <img className=" pe-auto" 
                  src={ "./../images/info.svg"} alt="info" width={16} height={16}
                  title="The option will allow for comparing the inspection results of the document in the Dashboard."/>
                </a>
              </div>
              <div className="ms-4 mt-1" style={{width: "300px"}}>
                <ReactSelectField
                  placeholder="Document Type"
                  name="documentType"
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                  options={[...documentType]}
                  value={selectedDocType || []}
                  onChange={(selected:any) => setSelectedDocType(selected)}
                  isDisabled={!toggles?.compareRequired}
                />
                {toggles.compareRequired && selectedDocType?.length === 0 && (
                  <small className="ms-2 text-danger fw-700">Document Type Required</small>
                )}
              </div>
            </div>
          </div>
          <hr className="pro-border d-none" />
          {/* <div className="row mb-2 d-none">
            <h5 className="mb-3">Dashboard Widgets:​​</h5>
            <div className="ms-4 mb-3" style={{position:"relative"}}>
            <div className="col-md-12 ms-2 mb-4 d-flex justify-content-start align-items-center">
                <div className="d-flex align-items-center me-1">
                  <div className="d-flex align-items-center">
                    <span className="">Enable Widgets on the Dashboard</span>
                    <a className="ms-1 align-self-center">
                      <img className=" pe-auto" 
                      src={ "./../images/info.svg"} alt="info" width={16} height={16}
                      title="The widgets selected in the drop-down will be visible in the Dashboard."/>
                    </a>
                  </div>
                  <div className="ms-4" style={{width: "300px"}}>
                    <ReactSelectField
                      placeholder="Select Widgets"
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                      options={[...widgets]}
                      value={selectedWidgets||""}
                      onChange={(selected:any) => setSelectedWidgets(selected)}
                    />
                    {selectedWidgets?.length === 0 && (
                      <small className="ms-2 text-danger fw-700">Select Dashboard Widgets</small>
                    )}
                  </div>
                </div>
            </div>
            </div>
          </div> */}
          <hr className="pro-border" />
          <div className="row mb-4">
            <h5 className="mb-3">White labelling of the application​:</h5>
            <div className="ms-2 mb-3">The default color will be shown to the user on the mobile application if no color is opted here​</div>
              <div className="col-md-7 ms-4 mb-4 d-flex justify-content-start align-item-center">
                <div className="me-1">
                  <h6 className="mt-1">Hex Color Code: </h6>
                </div>
                <div className="me-1">
                  <input type="text" value={`${mobileColorCode}`} onChange={(e)=>setMobileColorCode(e.target.value)} style={{width: "90px"}}/>
                  </div>
                <div className="me-3">
                  <ColorPicker color={mobileColorCode} onChange={(color:any) => setMobileColorCode(color.hex)} />
                </div>
            </div>
          </div>
          {configDetails?.isInterchangeEnabled === false && (
          <>
          <hr className="pro-border" />
          <div className="row mb-4">
            <h5 className="mb-3">Completed Document​:​​</h5>
            <div className="ms-4 mb-3" style={{position:"relative"}}>
              <div className="d-flex p-0 " >
                <ToggleSwitch
                  checked={toggles.completedDocOnMobile}
                  onChange={(value :any) => handleToggleChange("completedDocOnMobile", value)}
                  label="Show completed document on the mobile app for last​"
                />
                <input type="number" placeholder="0"
                  value={completedDocDays || null}
                  disabled={!toggles.completedDocOnMobile}
                  onChange={(e) => setCompletedDocDays(Number(e.target.value) || null)}
                  style={{width: "60px", height: "22px", marginTop: "5px"}}
                />&nbsp;
                <div className="mt-2">days</div>
              </div>
            </div>
          </div></>)}
          <hr className="pro-border" />
          <div className="row mb-4">
            <h5 className="mb-3">Claims Process:​​</h5>
            <div className="ms-4 mb-3" style={{position:"relative"}}>
              <div className="d-flex p-0 " >
                <ToggleSwitch
                  checked={toggles.webClaim}
                  onChange={(value :any) => handleToggleChange("webClaim", value)}
                  label="Enable Claims Process on the web application​"
                />
              </div>
              <div className="d-flex p-0 " >
                <ToggleSwitch
                  checked={toggles.mobileClaim}
                  onChange={(value :any) => handleToggleChange("mobileClaim", value)}
                  label="Enable Claims Process on the Mobile application​"
                  isDisabled={true}
                />
              </div>
            </div>
          </div>
          <hr className="pro-border" />
          <div className="row mb-4">
            <h5 className="mb-2">Inspection PDF Document:​​</h5>
            <div className="ms-4" style={{position:"relative"}}>
              <h6 className="eqp-sub-head">PDF Template Selection</h6>
              <div className="d-flex ms-4 mb-1">
                <div className="d-flex form-check mb-2 me-3">
                  <input 
                    className="form-check-input mt-1 me-1" 
                    type="radio"
                    role="button" 
                    name="pdfTemplate" 
                    id="pdfTemplateOne" 
                    checked={pdfTemplateOne}
                    onChange={() => {
                      setPdfTemplateOne(true);
                      setPdfTemplateTwo(false);
                    }}
                  />
                  <div className="form-check-label">PDF Template (Finloc)</div>
                </div>
                <div className="form-check mb-2">
                  <input 
                    className="form-check-input mt-1 me-1" 
                    type="radio" 
                    role="button" 
                    name="pdfTemplate" 
                    id="pdfTemplateTwo" 
                    checked={pdfTemplateTwo}
                    onChange={() => {
                      setPdfTemplateOne(false);
                      setPdfTemplateTwo(true);
                    }}
                  />
                  <div className="form-check-label" >PDF Template (Manac)</div>
                </div>
              </div>
            </div>
            
            <div className="ms-4" style={{position:"relative"}}>
              <h6 className="eqp-sub-head">Image Placement in PDF Template</h6>
              <div className="d-flex ms-4 mb-1">
                <div className="form-check mb-2 me-3">
                  <input 
                    className="form-check-input mt-1 me-1" 
                    type="radio" 
                    role="button" 
                    name="imageTemplate" 
                    id="pdfTemplateOneImagesBottom" 
                    checked={pdfTemplateOneImagesBottom}
                    onChange={() => {
                      setPdfTemplateOneImagesBottom(true);
                      setPdfTemplateOneImagesProcess(false);
                    }}
                  />
                  <div className="form-check-label">Images will be displayed at the end of the document</div>
                </div>
                <div className="form-check mb-2">
                  <input 
                    className="form-check-input mt-1 me-1" 
                    type="radio" 
                    role="button" 
                    name="imageTemplate" 
                    id="pdfTemplateOneImagesProcess" 
                    checked={pdfTemplateOneImagesProcess}
                    onChange={() => {
                      setPdfTemplateOneImagesBottom(false);
                      setPdfTemplateOneImagesProcess(true);
                    }}
                  />
                  <div className="form-check-label">Images will be displayed with each process</div>
                </div>
              </div>
            </div>
            {pdfTemplateTwo && (
              <div className="ms-4 mb-4" style={{position:"relative"}}>
                <h6 className="eqp-sub-head">Flagged Items & Status Color Highlighting</h6>

                <div className="ms-4 mt-2">
                  <table className="table status-color-table" style={{ width: '80%' }}>
                    <thead>
                      <tr>
                        <th style={{ backgroundColor: '#f8f9fa', paddingLeft: '8px' }}>Task Status</th>
                        <th style={{ backgroundColor: '#f8f9fa' }}>
                          Flagged Status
                          <span className="ms-1" title="Enabling this will add a separate section to consolidate all the tasks with specific status">
                            <i className="fa-solid fa-circle-info"></i>
                          </span>
                        </th>
                        <th style={{ width: '150px', backgroundColor: '#f8f9fa' }}>Color</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allTaskStatuses.map((statusObj: any, index: number) => {
                        const row = pdfConfigRequests.find((r) => r.status === statusObj) || { status: statusObj, isFlagged: false, color: '#000000' };
                        return (
                          <tr className="py-2" key={index} style={{ borderBottom: '1px solid #dee2e6' }}>
                            <td className="p-2 align-middle">
                              {statusObj}
                            </td>
                            <td className="p-2 align-middle">
                              <ToggleSwitch
                                  checked={row.isFlagged}
                                  onChange={(value: boolean) => handleStatusConfigChange(statusObj, 'isFlagged', value)}
                              />
                            </td>
                            <td className="p-2">
                              <div className="d-flex align-items-center">
                                <input type="text" value={row.color} className="form-control form-control-sm me-2" style={{ width: '80px', height: '38px' }} readOnly />
                                <ColorPicker color={row.color} onChange={(color: any) => handleStatusConfigChange(statusObj, 'color', color.hex)} />
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

          </div>
          <hr className="pro-border" />
          <div className="row mb-4">
            <h5 className="mb-3">Rental Charges:​​​</h5>
            <div className="ms-3 mb-3 d-flex">
              <div>Rental charge for late returns $</div>&nbsp;
              <input type="number" placeholder="0"
                value={lateChargePerDay}
                onChange={handleRentalChargesChange} style={{width: "60px", height: "22px"}}/>&nbsp;&nbsp;
              <div>Per day</div>
            </div>
          </div>
          {/* <hr className="pro-border" /> */}
          <div className="row mb-4 d-none">
            <h5 className="mb-3">Image for the Mobile Application landing screen:</h5>
            <div className="ms-2 mb-2">The default image will be shown to the user on the mobile application if no image is opted here</div>
            <div className="row ms-2 my-3 d-flex">
              <div className="col-md-8" ref={dropMobileImage} style={{position:"relative"}}>
                <FileUpload
                  acceptedFileTypes={['.png', '.jpg', '.jpeg']}
                  maxFileSize={5 * 1024 * 1024}
                  onFileUpload={mobileImageUpload}
                />
              </div> 
              <div className="col-md-4 px-3 py-1">
                {mobileImageFiles.name && (
                <div className="">
                  <h6>Uploaded Image:</h6>
                  <div className="mb-0 ms-2 d-flex justify-content-start align-item-center">
                    <div className="d-inline-block text-truncate mt-2" style={{maxWidth: "200px"}}>
                      <img
                        src="../../images/document.png"
                        alt=""
                        className={"financial-download-image mx-1"}
                        onClick={(e: any) => {
                          onDownloadDoc(mobileImageFiles?.path);
                        }}
                      />{mobileImageFiles.name}</div>
                      <button
                        type="button"
                        title="Delete"
                        className="btn btn-icon"
                        onClick={() => removeFile("mobileImage")}
                      >
                        <img src={"./../images/cancel.svg"} alt="cancel" width={24} height={24} />
                      </button>
                    </div>
                </div>
                )}
              </div>
            </div>
          </div>
      </div>
    </>
  );
};
export const onDownloadDoc = (filePath: string)=>{
  console.log("---------------", filePath);  
  const onDownloadSuccess = (dataObj: any) => {
    let link = document.createElement("a");
    link.download = "download";
    link.href = dataObj;
    link.target = "_blank";
    link.click();
  };
  const onLoginError = (err: any) => {
    BusyLoader.hideLoader();
    console.log(err);
  };
  
  if (filePath) {
    var qParam: string = "objectPath=" + filePath;
    NetworkManager.sendJsonRequest("api/session/downloadUrl", "", qParam, "GET", true, onDownloadSuccess, onLoginError);
  }
  
}

const CustomMultiValue = ({ data, index, selectProps }: any) => {
  const selectedValues = selectProps.value || [];
  if (index !== 0) return null;

  const visibleCount = 3;
  const visibleLabels = selectedValues.slice(0, visibleCount).map((item: any) => item.label);
  const remainingCount = selectedValues.length - visibleCount;

  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
      <span>{visibleLabels.join(",  ")}</span>
      {remainingCount > 0 && (
        <span className="count-badge" style={{ marginLeft: 5 }}>
          +{remainingCount}
        </span>
      )}
    </div>
  );
};

const CustomOption = (props: any) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
      />
      <label style={{ marginLeft: "8px" }}>{props.label}</label>
    </components.Option>
  );
};
export default GeneralDetails;

